var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientOnBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01098 8.83187C3.83226 8.91904 3.60955 8.83689 3.51926 8.65798L3.02986 7.67445C2.90253 7.41795 3.21182 7.21987 3.40444 7.44123L3.93968 8.05006L5.68894 7.1934C6.08621 7.00263 6.45153 7.01267 6.85064 7.28057L9.03051 8.74378C9.0694 8.78395 9.05551 8.84008 9.01245 8.86382C8.50175 9.12259 7.86696 8.98431 7.42246 8.68582L6.11538 7.80771L4.01098 8.83187ZM9.3236 7.72282L7.8526 6.73518C7.68036 6.61926 7.45117 6.66216 7.33449 6.83194C7.22337 6.99304 7.26689 7.2185 7.44052 7.33489L8.918 8.32801C9.22729 8.53567 9.43009 8.64566 9.79031 8.46903L11.2122 7.76025C11.4072 7.66897 11.5072 7.40882 11.4173 7.19112C11.3229 6.983 11.0321 6.90542 10.8418 6.98757L9.3236 7.72282ZM11.54 6.67083C11.5646 6.26829 11.9188 5.96843 12.3211 6.00266C12.7263 6.02776 13.0235 6.37006 12.9985 6.77169C12.9888 6.89857 12.9393 7.00902 12.8883 7.10441L12.8573 7.14868C12.7101 7.33945 12.4721 7.45446 12.2082 7.43347C11.8086 7.41476 11.5058 7.06652 11.54 6.67083Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6503 10H2.34878C2.15658 10 2 9.86272 2 9.69296V8.30665C2 8.13766 2.15658 8 2.34878 8C2.54187 8 2.69713 8.13766 2.69713 8.30665V9.3867H14.302V8.30665C14.302 8.13766 14.4581 8 14.6503 8C14.843 8 15 8.13766 15 8.30665V9.69296C15 9.86272 14.843 10 14.6503 10Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientOnBed);
export default __webpack_public_path__ + "static/media/Patient_on_bed.92f91bb3.svg";
export { ForwardRef as ReactComponent };